const events = window.__HPP_EVENTS__ || (window.__HPP_EVENTS__ = {});

/**
 * @param {string} name
 * @return {undefined | {on: (cb: any) => () => void, off: (fn: any) => void, reset: () => void, emit: (...args) => void}}
 */
function useEventBus(name) {
  if (typeof name !== 'string' || !name) {
    return;
  }
  let event = events[name];
  if (!event) {
    event = (function () {
      /**
       * @type {{once: boolean;cb: () => void}[]}
       */
      let listeners = [];

      function once(cb) {
        on(cb, true);
        return () => off(cb);
      }

      function on(cb, once = false) {
        listeners.push({ cb, once });
        return () => off(cb);
      }

      function off(fn) {
        const index = listeners.findIndex((item) => item.cb === fn);
        listeners.splice(index, 1);
      }

      function reset() {
        listeners = [];
      }

      function emit(...args) {
        for (let i = 0; i < listeners.length; i++) {
          const item = listeners[i];
          item.cb(...args);
          if (item.once) {
            listeners.splice(i, 1);
            i--;
          }
        }
      }

      return {
        once,
        on,
        off,
        reset,
        emit
      };
    })();

    events[name] = event;
  }
  return event;
}

export default useEventBus;
